import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div<{ isMain?: boolean, isSelected?: boolean }>`
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  cursor: pointer;
  z-index: 10;
  background-color: var(--white);
  color: var(--textDark);

  &:not(:last-child) {
    border-bottom: 1px solid var(--bgLightGrey);
  }

  ${({ isSelected }) => isSelected && css`
    border-left: 3px solid var(--blue);
    padding: 0 18px 0 15px;
  `};

  ${({ isMain }) => isMain && css`
    border-bottom: 1px solid var(--bgLightGrey);
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  `};

  ${({ isMain }) => !isMain && css`
    transition: all 0.1s ease-in;
    :hover {
      background: var(--rowHoverBG);
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
      z-index: 50;
    }
  `};

  * {
    user-select: none;
  }
`;

export const StyledGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StyledAllKeywordsText = styled.p`
  margin: 0;
  white-space: nowrap;
  color: var(--textDark);
`;

export const StyledNumOfKeywords = styled.p`
  background-color: var(--bgLightGrey);
  color: var(--textGrey);
  border-radius: 4px;
  font-family: Roboto;
  font-weight: 700;
  font-size: 10px;
  padding: 2px 4px;
  margin: 0;
  white-space: nowrap;
`;

export const StyledStatGroup = styled.p`
  display: flex;
  align-items: center;
  margin: 0;
`;

export const StyledSubText = styled.span`
  color: var(--textGrey);
  white-space: nowrap;

  @media only screen and (max-width: 520px) {
    display: none;
  }
`;

export const StyledNumOfSearches = styled.span`
  color: var(--textDark);
`;

export const StyledKeywordDifficulty = styled.div`
  background-color: var(--mainColor);
  color: var(--white);
  font-weight: bold;
  width: 38px;
  line-height: 21px;
  height: 21px;
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
`;
